import * as React from "react";
import { useDispatch } from "react-redux";
import FlexLayout from "../../../controls/FlexLayout";
import FormInput from "../../../controls/FormInput";
import { IconButton } from "../../../controls/TooltipControls";
import opn from "../../../util/opn";
import { setModAttribute } from "../actions/mods";
function isURLValid(url) {
    try {
        // tslint:disable-next-line:no-unused-expression
        new URL(url);
    }
    catch (e) {
        return false;
    }
    return true;
}
function URLInput(props) {
    const { t, gameId, mod } = props;
    const dispatch = useDispatch();
    const updateURL = React.useCallback((newUrl) => {
        dispatch(setModAttribute(gameId, mod.id, "url", newUrl));
    }, [gameId, mod]);
    const openSite = React.useCallback(() => {
        opn(mod.attributes?.url).catch(() => null);
    }, [mod]);
    return (React.createElement(FlexLayout, { type: "row" },
        React.createElement(FormInput, { style: { flex: "1 1 0" }, value: mod.attributes?.url, onChange: updateURL }),
        React.createElement(IconButton, { icon: "open-in-browser", disabled: !isURLValid(mod.attributes?.url), tooltip: t("Open website in your browser"), onClick: openSite })));
}
export default URLInput;
